import { MappedClass, MappedProperty } from '@h5s/util-object';

@MappedClass()
export class ZPrinterError {
  @MappedProperty()
  code?: string | null;

  @MappedProperty()
  description?: string | null;
}
